import { render, staticRenderFns } from "./nbpFundsComponent.vue?vue&type=template&id=018a8afe&"
import script from "./nbpFundsComponent.vue?vue&type=script&lang=js&"
export * from "./nbpFundsComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports